import axios from "axios";

const getCdlEndorsements = () => axios.get("Rfid/GetCdlEndorsment");

const getSubEndorsements = () => axios.get("Rfid/GetSUBEndorsment");

const updateCdlEndorsement = (row, status = "I") =>
  axios.post("Rfid/UpdateCDLEndorsment", {
    P_hbl_id: row.HBL_ID,
    p_status: status,
  });
 
const formatApiDate = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    throw new Error("The subcontract endorsement date is invalid.");
  }

  const pad = (part) => String(part).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
};

const updateSubEndorsement = (row, status = "I") =>
  axios.post("Rfid/UpdateSUBEndorsment", {
    p_status: status,
    p_uid: row.TFT_UID,
    p_date: formatApiDate(row.TFT_DATETIME),
  });

export default {
  getCdlEndorsements,
  getSubEndorsements,
  updateCdlEndorsement,
  updateSubEndorsement,
};